import http from "../utility/http";

/**
 * Create transfer-in (same as portal "Request A New Transfer In").
 * Partner Onboarding Step 8c: POST /partner/v1/transfer/transfer-in-request
 * @see portal-be `src/partner-api/docs/onboarding-spec.ts`
 */
const Create = async (transferRequest) => {
  return await http.post("/v1/transfer/transfer-in-request", transferRequest);
};

const Update = async (transferRequest) => {
  return await http.put(`/v1/transfer/transfer-in-request`, transferRequest);
};

const Delete = async (id) => {
  return await http.delete(`/v1/transfer/transfer-in-request/${id}`, {});
};

/**
 * Transfer-in list (paginated). Same contract as Partner Onboarding Step 8a:
 * GET /partner/v1/transfer/transfer-in-request/list?q=&page=&limit=&sortBy=&sortOrder=&statusId=&futureFillOnly=
 * @see portal-be `src/partner-api/docs/onboarding-spec.ts`
 */
const GetAll = async (keyword, page = 1, limit = 50, sort, statusId, futureFillOnly) => {
  //add pagination + sorting + filteration
  let sortQuery = "";
  if (sort) {
    sortQuery = `&sortBy=${sort?.sortBy}&sortOrder=${sort?.sortOrder}`;
  }

  let statusQuery = "";
  if (statusId) {
    statusQuery = `&statusId=${statusId}`;
  }

  let futureFillQuery = "";
  if (futureFillOnly) {
    futureFillQuery = "&futureFillOnly=1";
  }

  return await http.get(
    `/v1/transfer/transfer-in-request/list?q=${keyword}&page=${page}&limit=${limit}${sortQuery}${statusQuery}${futureFillQuery}`,
    true
  );
};

const GetById = async (id) => {
  return await http.get(`/v1/transfer/transfer-in-request/${id}`);
};

const Accept = async (transferRequestAction) => {
  return await http.post(
    "/v1/transfer/transfer-in-request/accept",
    transferRequestAction
  );
};

const Reject = async (transferRequestAction) => {
  return await http.post(
    "/v1/transfer/transfer-in-request/reject",
    transferRequestAction
  );
};

const Cancel = async (transferRequestAction) => {
  return await http.post(
    "/v1/transfer/transfer-in-request/cancel",
    transferRequestAction
  );
};

const GetTransfersByBranch = async (branchId, statusId, isPaid, fromDate, toDate, page = 1, limit = 50) => {
  // When isPaid is true (1), increase limit to 100000 to show more paid transfers
  const effectiveLimit = 100000

  let query = `branchId=${branchId}&page=${page}&limit=${effectiveLimit}`;

  if (statusId) query += `&statusId=${statusId}`;
  if (isPaid !== null && isPaid !== undefined) query += `&isPaid=${isPaid}`;
  if (fromDate) query += `&fromDate=${fromDate}`;
  if (toDate) query += `&toDate=${toDate}`;

  return await http.get(`/v1/transfer/transfers/by-branch?${query}`);
};

const TogglePaymentStatus = async (requestId) => {
  // Use PATCH with requestId in URL path (matching the API screenshot pattern)
  // This follows RESTful convention for updating a specific resource property
  return await http.patch(`/v1/transfer/transfer-request/${requestId}/toggle-is-paid`);
};

const BulkTogglePaymentStatus = async (requestIds) => {
  // Bulk toggle payment status for multiple transfer requests
  // Send array of IDs in request body
  return await http.post(`/v1/transfer/transfer-request/bulk/toggle-is-paid`, { ids: requestIds });
};

const BulkMarkPaymentStatus = async (items) => {
  return await http.post(`/v1/transfer/transfer-request/bulk/mark-is-paid`, { items });
};

const UpdateNotes = async (requestId, notes) => {
  // Update only the notes field for a specific transfer request
  // Uses PATCH method to partially update the resource
  return await http.patch(`/v1/transfer/transfer-request/${requestId}/notes`, { notes });
};

const UpdateRxIssueDate = async (requestId, rxIssueDate, showInAllInDays) => {
  return await http.patch(`/v1/transfer/transfer-request/${requestId}/rx-issue-date`, {
    rxIssueDate,
    ...(showInAllInDays === undefined || showInAllInDays === null
      ? {}
      : { showInAllInDays }),
  });
};

/**
 * Tells when the request would start showing in the All tab if the given Date Written were saved,
 * without saving anything. Used to confirm the future fill schedule with the pharmacist.
 */
const GetFutureFillPreview = async (requestId, rxIssueDate) => {
  return await http.get(
    `/v1/transfer/transfer-request/${requestId}/future-fill/preview?rxIssueDate=${rxIssueDate}`,
    true
  );
};

const api = {
  GetById,
  GetAll,
  Create,
  Update,
  Delete,
  Accept,
  Reject,
  Cancel,
  GetTransfersByBranch,
  TogglePaymentStatus,
  BulkTogglePaymentStatus,
  BulkMarkPaymentStatus,
  UpdateNotes,
  UpdateRxIssueDate,
  GetFutureFillPreview,
};

export default api;
